module.exports = __webpack_public_path__ + "img/AMEX.70406a78.svg";